var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.771,
    height: 63.771,
    viewBox: "0 0 63.771 63.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1207",
    "data-name": "Ellipse 1207",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(5.375 4.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8600",
    "data-name": "Path 8600",
    d: "M36.2,32.742l-8.079-8.079L36.2,16.584a2.45,2.45,0,1,0-3.464-3.464L24.657,21.2,16.578,13.12a2.344,2.344,0,0,0-3.464,0,2.367,2.367,0,0,0,0,3.464l8.079,8.079-8.079,8.079a2.369,2.369,0,0,0,0,3.464,2.433,2.433,0,0,0,3.464,0l8.079-8.079,8.079,8.079a2.461,2.461,0,0,0,3.464,0A2.434,2.434,0,0,0,36.2,32.742Z",
    transform: "translate(10.603 10.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8601",
    "data-name": "Path 8601",
    d: "M35.261,7.667A27.6,27.6,0,0,1,54.775,54.775,27.6,27.6,0,0,1,15.746,15.746,27.411,27.411,0,0,1,35.261,7.667m0-4.292A31.885,31.885,0,1,0,67.146,35.261,31.881,31.881,0,0,0,35.261,3.375Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.7c560ac9.svg";
export { ForwardRef as ReactComponent };